import React from "react"
import PropTypes from "prop-types"
import {
  Stack,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import i18n from "i18n"

const PurchaseOrderHeader = ({
  title = "",
  showBack = false,
  onBack,
  onSave,
  onConvertToExpense,
  convertToExpenseDisabled = false,
  convertToExpenseLoading = false,
  isSaving = false,
}) => {
  const saveLabel = isSaving ? (
    <CircularProgress size={22} color="inherit" />
  ) : (
    i18n.t("purchaseOrders.save")
  )

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "100%", marginBottom: "20px" }}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        {showBack && (
          <IconButton onClick={onBack} size="small">
            <ChevronLeftIcon />
          </IconButton>
        )}
        <Typography variant="h6" component="h1">
          {title}
        </Typography>
      </Stack>
      <Stack direction="row" gap={1}>
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          disabled={isSaving}
          sx={{ minWidth: "180px" }}
        >
          {saveLabel}
        </Button>
        <Button
          variant="contained"
          color="branded"
          onClick={onConvertToExpense}
          disabled={
            convertToExpenseDisabled || isSaving || convertToExpenseLoading
          }
          sx={{ minWidth: "180px" }}
        >
          {convertToExpenseLoading ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            i18n.t("purchaseOrders.convertToExpense")
          )}
        </Button>
      </Stack>
    </Stack>
  )
}

export default PurchaseOrderHeader

PurchaseOrderHeader.propTypes = {
  title: PropTypes.string,
  showBack: PropTypes.bool,
  onBack: PropTypes.func,
  onSave: PropTypes.func,
  onConvertToExpense: PropTypes.func,
  convertToExpenseDisabled: PropTypes.bool,
  convertToExpenseLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
}
